<template>
	<view class="box">
		<u-parse :content="info.code"></u-parse>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				info: {}
			};
		},
		onLoad() {
			this.$u.api.getSysDict({ dicCode: 'SYSTEM', label: 'PRICING_RULE' })
				.then(res => {
					if (res.code === 200) {
						this.info = res.data
					}
				})
		}
	}
</script>
<style>
	page {
		background-color: #f7f7f7;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 20rpx;
		box-sizing: border-box;
		.box_nr {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
		}
	}
</style>
